module.exports = __webpack_public_path__ + "static/media/istelogo.9ee4c205.png";